// 默认easyMock生成的文件在src/api/template下
import { getTheme } from '@/api'
import * as types from './mutation-types'
export default {
  async setUserInfo (context) {
    // userInfo模拟数据，真实开发环境中可以去掉，使用接口获取
    const res = await getTheme()

     // portal.locale：从智能应用平台门户跳转带过来的 cookie，否则读取浏览器语言
    let cookie = document.cookie, languageId = 'zh_CN'

    function getBrowserLan() {
      const lan = navigator.language.toLowerCase()
      const obj = {
        'zh-cn': 'zh_CN',
        'en': 'en_US',
        'en-us': 'en_US'
      }
      return obj[lan] || lan
    }

    if (cookie) {
      const cookieObj = {};
      cookie.split('; ').forEach(coo => {
        let obj = coo.split('=');
        cookieObj[obj[0]] = obj[1];
      })

      if (cookieObj['portal.locale']) {
        languageId = cookieObj['portal.locale'];
      } else if (cookieObj['browserLan']) {
        languageId = cookieObj['browserLan'];
      } else {
        languageId = getBrowserLan()
        document.cookie += `; browserLan=${languageId}`
      }
    } else {
      languageId = getBrowserLan()
      document.cookie = `browserLan=${languageId}`
    }

    let data = {
      languageId,
      'skin': res.data.data.theme,
      'code': [
        `${process.env.VUE_APP_CONTEXT}_001`,
        `${process.env.VUE_APP_CONTEXT}_002`
      ]
    }
    // let { data } = await getUserInfo({ noMsg: true })
    context.commit(types.SET_USER_INFO, data)
    return {
      userInfo: data
    }
  }
}
